import React from 'react'
import moment from 'moment-timezone'

export default function ReleaseNote({
  tag_name,
  published_at,
  public_body_html,
  isLatest,
  isUnread,
  onTagClick,
  noteRef,
}) {
  return (
    <div className="post_container">
      <div className="hashtag_version">
        <div className="badge_container">
          {isLatest && <a className="badge latest">LATEST</a>}
          {isUnread && <a className="badge unread">UNREAD</a>}
        </div>
        <div className="hashtag-style">
          <a href="#" onClick={(e) => onTagClick(e, noteRef, tag_name)}>
            #
          </a>
        </div>
        <div className="version_container">
          Version {tag_name}
          <span>
            released{' '}
            {moment
              .utc(published_at)
              .tz('America/Denver')
              .format('D MMMM, YYYY')}
          </span>
        </div>
      </div>

      <div
        className="post_content"
        dangerouslySetInnerHTML={{ __html: public_body_html }}
      />
    </div>
  )
}
